<template>
  <Container>
    <Title
      v-if="[donationWayType.ECPAY_SINGLE_ATM , donationWayType.ECPAY_SINGLE_CVS].includes(donationWay)"
      strong
      bold
    >
      付款資訊
    </Title>
    <Title
      v-else
      strong
      bold
    >
      捐款結果
    </Title>

    <Form>
      <FormCard>
        <BreadCrumb :items="breadCrumbitems" />
        <FormHeading>
          <span v-if="submitted && !submittedError">謝謝您的支持</span>
          <span v-else-if="submitted && submittedError">捐款失敗</span>
        </FormHeading>

        <template v-if="donationPeriod == donationPeriodType.DONATION_SINGLE">
          <FormRow>
            <PreviewSectionTitle>
              {{ donationWay + '資訊' }}
            </PreviewSectionTitle>
          </FormRow>
          <div :class="$style.orderInfo">
            <template v-if="donationWay === donationWayType.ECPAY_SINGLE_ATM">
              <FormRow>跨行轉帳若非使用同銀行ATM櫃員機，須支付跨行手續費 15 元，請務必於繳費期限內進行繳費（若使用第一銀行ATM櫃員機，請選擇「繳費」按鈕）</FormRow>
            </template>
            <template v-else-if="donationWay === donationWayType.ECPAY_SINGLE_CVS">
              <FormRow>請至 7-ELEVEN / 全家 / 萊爾富 / OK 超商 多媒體機台列印繳費單繳費</FormRow>
            </template>
          </div>
          <template v-if="[donationWayType.ECPAY_SINGLE_ATM , donationWayType.ECPAY_SINGLE_CVS , donationWayType.ECPAY_SINGLE_CREDIT].includes(donationWay)">
            <FormRow>
              <PreviewField
                v-for="(item,index) in formattedEcpayInfo"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
          <template v-else-if="donationWay === donationWayType.JKOPAY_SINGLE">
            <FormRow>
              <PreviewField
                v-for="(item,index) in formattedJKOPayInfo"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
          <template v-else-if="donationWay === donationWayType.LINEPAY_SINGLE">
            <FormRow>
              <PreviewField
                v-for="(item,index) in formattedLinePayInfo"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
          <template v-else>
            <FormRow>
              <PreviewField
                v-for="(item,index) in formattedJKOPayInfo"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
          <div
            v-if="isATMOverLimit"
            :class="$style.warningInfo"
          >
            <p>
              提醒您，由於捐款金額大於 3 萬元，需至以下銀行之實體ATM櫃員機，使用「繳費功能」完成捐款，謝謝！
            </p>
            <p>
              銀行列表：台新銀行、玉山銀行、中國信託、華南銀行、第一銀行、富邦銀行、台灣銀行、土地銀行、彰化銀行、永豐銀行、國泰世華銀行。
            </p>
          </div>
        </template>

        <template v-if="donationPeriod !== donationPeriodType.DONATION_SINGLE">
          <FormRow>
            <PreviewSectionTitle>捐款資訊</PreviewSectionTitle>
          </FormRow>
          <FormRow>
            <PreviewField
              v-for="(item,index) in formattedEcpayInfo"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </FormRow>
        </template>

        <template v-if="hasReceiptInfo && !isAnonymous">
          <FormRow>
            <PreviewSectionTitle>收據資訊</PreviewSectionTitle>
          </FormRow>
          <FormRow>
            <PreviewField
              v-for="(item,index) in formattedReceiptInfo"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </FormRow>
        </template>

        <div :class="$style.warningInfo">
          <FormRow>
            <p> 提醒您，請勿按上一頁或重新整理，避免資料重複送出，謝謝！</p>
          </FormRow>
        </div>

        <br>
        <Align right>
          <Button
            :small="isMobile"
            @click.native="submit()"
          >
            確認
          </Button>
        </Align>
      </FormCard>
      <p :class="$style.text">
        如有任何問題，歡迎寄信至 fin@teach4taiwan.org 詢問
      </p>
    </Form>
  </Container>
</template>

<script>
import _ from 'lodash';
import { saveStore, clear as clearStorage } from '@/lib/storage';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { DONATION_WAY_TO_DONATION_GA_INFO } from '@/configs/GAconfig.js';
import donationWayType from '@/configs/donationWay';
import donationPeriodType from '@/configs/donationPeriod';

import Container from '../../components/layout/Container';
import Align from '../../components/layout/Align';
import Title from '../../components/Title';
import Form from '../../components/form/Form';
import FormCard from '../../components/form/FormCard';
import FormHeading from '../../components/form/FormHeading';
import FormRow from '../../components/form/FormRow';

import Button from '../../components/buttons/Button';

import PreviewSectionTitle from '../../components/preview/PreviewSectionTitle';
import PreviewField from '../../components/preview/PreviewField';

import BreadCrumb from '../../components/others/BreadCrumb';

export default {
  components: {
    Container,
    Align,

    Title,

    Form,
    FormCard,
    FormHeading,
    FormRow,

    Button,

    PreviewSectionTitle,
    PreviewField,

    BreadCrumb,
  },
  data() {
    return {
      donationWayType: Object.freeze(donationWayType),
      donationPeriodType: Object.freeze(donationPeriodType),
    };
  },

  computed: {
    formattedEcpayInfo() {
      return _.filter(this.ecpayInfo, item => item.value);
    },

    formattedLinePayInfo() {
      return _.filter(this.lineDonationResult, item => item.value);
    },

    formattedJKOPayInfo() {
      return _.filter(this.donateResultInfo, item => item.value);
    },

    formattedReceiptInfo() {
      return _.filter(this.receiptFields, item => item.value);
    },

    hasReceiptInfo() {
      return _.filter(this.receiptFields, item => item.value).length > 0;
    },

    paymentPeriod() {
      switch(this.$route.name) {
        case 'period-result':
          return donationPeriodType.DONATION_PERIOD;
        case 'single-result':
          return donationPeriodType.DONATION_SINGLE;
        default:
          return '';
      }
    },

    GAtransactionId() {
      switch(this.donationWay) {
        case donationWayType.LINEPAY_SINGLE:
          return this.linePayOppoId;
        case donationWayType.ECPAY_SINGLE_CREDIT:
        case donationWayType.ECPAY_PERIOD_CREDIT:
        case donationWayType.ECPAY_SINGLE_ATM:
        case donationWayType.ECPAY_SINGLE_CVS:
          return this.ecpayOppoId;
        default:
          return '';
      }
    },

    ...mapState({
      breadCrumbitems: state => state.breadCrumb.items,
    }),

    ...mapFields('donation', [
      'donationPeriod',
      'donationWay',
      'amount',

      'submitting',
      'submitted',
      'submittedError',
    ]),

    ...mapFields('donation/ECPay', {
      ecpayOppoId: 'oppoId',
    }),

    ...mapFields('donation/LinePay', {
      transactionId: 'transactionId',
      linePayOppoId: 'oppoId',
    }),

    ...mapGetters('donation', [
      'isAnonymous',
      'donationInfo',
      'receiptFields',
    ]),

    ...mapGetters('ui', [
      'isMobile',
    ]),

    ...mapGetters('donation/ECPay', [
      'ecpayInfo',
    ]),

    ...mapGetters('donation/JKOPay', [
      'donateResultInfo',
    ]),

    ...mapGetters('donation/LinePay', [
      'lineDonationResult',
    ]),

    isATMOverLimit() {
      return this.donationWay == 'ATM轉帳繳款' && this.amount > 30000;
    },
  },

  mounted() {
    this.updateStep('4');
    // 如果網址帶有，ECPay=true ，代表是 3D 驗證回來的信用卡單筆或是定期定額
    if(this.isECPayCreditCardTransaction()) {
      this.updateECpayCreditCardPaymentInfo();
    }

    if(this.isLinePayTransaction()) { // 如果網址帶有transactionId，就會需要跟LINE SERVER發確認
      const loader = this.$loading.show();
      try {
        this.finishLinePayTransaction().then(()=>{
          loader.hide();
          saveStore();
        }).catch(()=>{
          loader.hide();
        });
      } catch(e) {
        alert(e);
      }
    }
    this.sendGA();
  },

  methods: {
    ...mapActions('donation/LinePay', {
      finishLinePayTransaction: 'finishTransaction',
    }),

    ...mapActions('donation/LinePay', {
      finishECPayTransaction: 'finishTransaction',
    }),

    ...mapActions('donation/ECPay', {
      updateECPayResultToSaleforce: 'updateResultToSaleforce',
    }),

    ...mapMutations('donation/ECPay', {
      updateECPayCreditCardResult: 'updateCreditCardResult',
    }),

    ...mapMutations({
      updateStep: 'breadCrumb/updateStep',
      resetFields: 'donation/resetFields',
    }),

    sendGA() {
      if(!this.donationWay) {
        this.donationWay = donationWayType.JKOPAY_SINGLE;
      }
      const GA_DONATION_INFO = DONATION_WAY_TO_DONATION_GA_INFO[this.donationWay];
      const GA_PARM = {
        ecommerce: {
          currency: 'TWD',
          value: this.amount,
          items: [GA_DONATION_INFO['item']],
          payment_type: GA_DONATION_INFO['payment_type'],
          transaction_id: this.GAtransactionId,
        },
      };
      // 有交易 ID 才送 GA
      if(this.GAtransactionId) {
        this.$gtag.event('TD_purchase', GA_PARM);
        console.log('TD_purchase', GA_PARM);
      }
    },

    updateECpayCreditCardPaymentInfo() {
      const loader = this.$loading.show();
      const urlParams = new URLSearchParams(window.location.search);
      const paymentPeriod = this.paymentPeriod;
      const payload = {
        'oppoID': urlParams.get('oppoID') ? urlParams.get('oppoID') : '',
        'amount': urlParams.get('amount') ? urlParams.get('amount') : '',
        'tradeNo': urlParams.get('tradeNo') ? urlParams.get('tradeNo') : '',
        'tradeStatus': urlParams.get('tradeStatus') ? urlParams.get('tradeStatus') : '',
        'tradeStatusMessage': urlParams.get('msg') ? urlParams.get('msg') : '',
        'paymentPeriod': paymentPeriod,
      };

      this.updateECPayCreditCardResult(payload);
      if(this.donationPeriod == donationPeriodType.DONATION_SINGLE) {
        this.donationWay = donationWayType.ECPAY_SINGLE_CREDIT;
        this.updateECPayResultToSaleforce();
      } else if(this.donationPeriod == donationPeriodType.DONATION_PERIOD) {
        this.donationWay = donationWayType.ECPAY_PERIOD_CREDIT;
      }
      loader.hide();
      saveStore();
    },

    isECPayCreditCardTransaction() {
      const urlParams = new URLSearchParams(window.location.search);
      const isECPay = urlParams.get('ECPay');
      return isECPay;
    },

    isLinePayTransaction() {
      // 以下是 LINE PAY 的捐款確認流程：
      // 當捐款人的頁面從 LINE 的 APP 跳轉到 Web 時，此跳轉的 url 中會帶上 LINE 的 transactionId
      // 因此只要網址有 transactionId，就表示這會是 LINE PAY 付款
      const urlParams = new URLSearchParams(window.location.search);
      this.transactionId = urlParams.get('transactionId');
      if(this.transactionId !== null) {
        this.donationWay = donationWayType.LINEPAY_SINGLE;
      }
      return this.donationWay == donationWayType.LINEPAY_SINGLE ? true : false;
    },

    submit() {
      clearStorage();
      this.resetFields();
      this.$router.push({ name: 'donation-way' });
    },

  },

};

</script>

<style lang="scss" module>
.orderInfo {
  font-size: 1.2rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #3c3c3c;
  opacity: 0.52;
}

.warningInfo {
  font-size: 1.2rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #fa186b;
  opacity: 0.52;
}

.text {
  font-size: 1.4rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px 10px;
}
</style>
